export const layout = {
  layout_navTab_invite: 'Invite',
  layout_navTab_calendar: 'Calendar',
  layout_navTab_questionnaires: 'Questionnaires',
  layout_navTab_profile: 'Profile',
  layout_navTab_study: 'Study',
};
